import React from 'react';
import {
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    Divider,
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    Grid,
    Icon,
    IconButton,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Paper,
    Radio,
    RadioGroup,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Typography,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
import GoogleMapReact from 'google-map-react';
import moment from 'moment-timezone';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ContentCopyIcon from '@material-ui/icons/FileCopy';
import { DatePicker, DateTimePicker } from 'material-ui-pickers';
import WarningIcon from '@material-ui/icons/Error';
import AddIcon from '@material-ui/icons/Add';
import classNames from 'classnames';
import GaugeChart from 'react-gauge-chart';
import { isEmpty } from 'lodash';
import PhoneIcon from '@material-ui/icons/Phone';
import HybridTextField from '../hybridTextField';
import titalise from '../../utilities/titalise';
import {
    titles,
    counties,
    countries,
    intDialCodes,
} from '../../utilities/menuOptions';
import Tile from '../../containers/tile';
import ContactCreditScore from './contactCreditScore';
import titaliseWithHyphen from '../../utilities/titaliseWithHyphen';
import ukFlag from '../../ukFlag.png';
import roiFlag from '../../roiFlag.png';
import ItemHistory from './itemHistory';

const CustomTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
        whiteSpace: 'nowrap',
    },
}))(TableCell);

const styles = (theme) => ({
    label: {
        fontSize: 11,
        fontWeight: 400,
        color: 'rgba(0, 0, 0, 0.54)',
        marginBottom: 7,
        marginTop: theme.spacing.unit * 2,
        width: '100%',
        textAlign: 'left',
    },
    row: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.background.default,
        },
    },
    tableHead: {
        fontWeight: 'bold',
        fontSize: 14,
    },
    paper: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        overflowX: 'auto',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    tileBottomDivider: {
        marginTop: theme.spacing.unit * 3,
        // marginBottom: theme.spacing.unit * 2,
    },
    dialogDivider: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        marginLeft: -24,
        marginRight: -24,
    },
    bottomBarContainer: {
        width: '100%',
        textAlign: 'right',
    },
    textButton: {
        marginTop: theme.spacing.unit * 1.5,
        marginBottom: 0,
    },
    dialogActions: {
        marginRight: theme.spacing.unit * 2.5,
    },
    nameField: {
        width: 350,
    },
    addressField: {
        width: 250,
    },
    postcodeField: {
        width: 120,
    },
    countryField: {
        width: 200,
        marginLeft: theme.spacing.unit * 3,
    },
    emailField: {
        width: 350,
    },
    rightOfFieldButton: {
        marginTop: 10,
        marginLeft: theme.spacing.unit * 3,
        color: 'rgba(0, 121, 255, 0.87)',
    },
    dialogContentContainer: {
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2,
    },
    contactVulnerabilityDialogContentContainer: {
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 3,
        minWidth: 550,
    },
    dialogButton: {
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 1,
    },
    dialogContent: {
        paddingBottom: 0,
        minWidth: 400,
    },
    formHelperText: {
        color: '#f44336',
    },
    contactLocationIcon: {
        color: 'red',
        fontSize: 30,
        position: 'absolute',
        transform: 'translate(-50%, -100%)',
    },
    branchLocationIcon: {
        color: 'blue',
        fontSize: 30,
        position: 'absolute',
        transform: 'translate(-50%, -100%)',
    },
    progressContainer: {
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        width: 60,
    },
    progress: {
        opacity: '.5',
    },
    inputLabel: {
        backgroundColor: '#fff',
        paddingLeft: 8,
        marginLeft: -5,
        paddingRight: 8,
    },
    menuFormControl: {
        marginBottom: theme.spacing.unit * 1,
        marginTop: theme.spacing.unit * 2,
    },
    // agents: {
    //     marginRight: theme.spacing.unit * 3,
    // },
    // 'agents:not(:first-child)': {
    //     marginLeft: 0,
    //     backgroundColor: 'red',
    // },
    debtCompanyContainer: {
        height: '100%',
    },
    debtCompany: {
        boxShadow: '0 0 0 3px #f44336, 0 0 0 2px #f44336 inset',
        border: '2px solid transparent',
        borderRadius: 4,
        display: 'inline-block',
        padding: '5px 2px',
        color: '#f44336',
        fontSize: 24,
        textTransform: 'uppercase',
        textAlign: 'center',
        // opacity: 0.6,
        fontWeight: 900,
        position: 'absolute',
        top: '60%',
        left: '50%',
        transform: 'rotate(-5deg) translate(-50%,-50%)',
        minWidth: '80%',
        background: '#ffffff7d',
    },
    debtCompanyName: {
        fontSize: 80,
    },
    debtNoContact: {
        fontSize: 40,
    },
    textFieldLabel: {
        color: 'rgba(0, 0, 0, 0.54)',
        fontSize: 11,
        fontWeight: 400,
        marginBottom: 4,
    },
    creditScoreContainer: {
        marginBottom: 16,
    },
    dialogCreditScoreContainer: {
        marginBottom: 8,
        marginTop: 8,
        minHeight: 69,
    },
    dialogTitle: {
        marginBottom: 16,
    },
    dialogSubTitle: {
        fontSize: 18,
        fontWeight: 500,
        marginBottom: 16,
    },
    cardRadio: {
        // paddingTop: '0px',
    },
    radio: {
        '&:first-of-type': {
            marginTop: 8,
        },
    },
    radioButtonsContainer: {
        marginLeft: theme.spacing.unit * 2,
    },
    circle: {
        borderRadius: '50%',
        width: 20,
        height: 20,
        paddingTop: 1,
        background: '#fff',
        border: '2px solid #f44336',
        color: '#f44336',
        textAlign: 'center',
        fontWeight: 600,
        font: '14px Arial, sans-serif',
    },
    historyPaper: {
        backgroundColor: theme.palette.background.default,
        border: '1px solid #e0e0e0',
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'column',
        marginBottom: theme.spacing.unit * 2,
        overflowX: 'auto',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 1}px`,
        width: '100%',
    },
    blackTableIcons: {
        color: '#000000',
        fontSize: 22,
        opacity: 0.6,
    },
    bumpTop2U: {
        marginTop: theme.spacing.unit * 2,
    },
    contentCopyIcon: {
        cursor: 'pointer',
        color: '#0074cc',
        '&:hover': {
            color: '#0a95ff',
        },
        '&:active': {
            color: '#aaa',
        },
    },
    rightButton: {
        textAlign: 'right',
    },
    phoneNumber: {
        marginTop: -12,
    },
    alertPhoneNumber: {
        paddingBottom: 16,
        color: '#f00',
        fontWeight: 500,
    },
    emptyPhoneNumber: {
        minHeight: 35,
    },
    flag: {
        width: 100,
        marginBottom: 16,
    },
    phoneNumberContainer: {
        display: 'flex',
        alignItems: 'left',
        gap: 8,
    },
    phoneNumberIntDialCode: {
        marginTop: 13,
        marginRight: 8,
    },
    intDialCodeContainer: {
        display: 'flex',
        alignItems: 'left',
        minWidth: 110,
    },
    intDialCode: {
        minWidth: 90,
        marginRight: 24,
    },
    intDialCodeFlag: {
        width: 20,
        marginRight: 8,
    },
});

class ItemChildren extends React.Component {
    state = {
    };

    componentDidMount() {
    }

    handleRowClick = (itemCode) => {
        window.location.href = `/item/${itemCode}`;
    };

    render() {
        const {
            classes,
            errors,
            fetchItemData,
            fetchHistoriesData,
            item,
            itemLoading,
            itemHistoriesLoading,
            itemChildrenLoading,
        } = this.props;
        const {
        } = this.state;

        return (
            <>
                <Tile
                    tileTitle="Item Children"
                    refreshAction={fetchItemData}
                    refreshing={itemChildrenLoading && itemLoading}
                    style
                >
                    { !itemLoading
                        ? (
                            <>
                                <Grid container spacing={0}>
                                    <Grid item xs={12}>
                                        <HybridTextField
                                            label="Children Quantity"
                                            text={item.children.length}
                                        />
                                    </Grid>
                                </Grid>

                                <div className={classes.componentContainer}>
                                    <div
                                        className={classes.label}
                                    >
                                        Children
                                    </div>
                                    <Paper>
                                        <Table className={classes.table} padding="dense">
                                            <TableHead>
                                                <TableRow>
                                                    <CustomTableCell>#</CustomTableCell>
                                                    <CustomTableCell align="left">Item Code</CustomTableCell>
                                                    <CustomTableCell align="right">Length</CustomTableCell>
                                                    <CustomTableCell align="right">Width</CustomTableCell>
                                                    <CustomTableCell align="right">Agreement Code</CustomTableCell>
                                                    <CustomTableCell align="left">Created By</CustomTableCell>
                                                    <CustomTableCell align="right">Created Time & Date</CustomTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {item.children.map((child, i) => {
                                                    i++;
                                                    return (
                                                        <TableRow
                                                            className={classes.row}
                                                            key={child.code}
                                                            onClick={() => this.handleRowClick(child.code)}
                                                        >
                                                            <CustomTableCell component="th" scope="row">{i}</CustomTableCell>
                                                            <CustomTableCell align="left">{`SC${child.code}`}</CustomTableCell>
                                                            <CustomTableCell align="right">
                                                                {child.length}
                                                                m
                                                            </CustomTableCell>
                                                            <CustomTableCell align="right">
                                                                {child.width}
                                                                m
                                                            </CustomTableCell>
                                                            <CustomTableCell align="right">{child.agreementCode ? `RA${child.agreementCode}` : ''}</CustomTableCell>
                                                            <CustomTableCell align="left">{child.createdBy}</CustomTableCell>
                                                            <CustomTableCell align="right">{moment(child.createdDateTime).format('HH:mm DD/MM/YYYY')}</CustomTableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </Paper>
                                </div>
                            </>
                        )
                        : (
                            <div className={classes.progressContainer}>
                                <CircularProgress className={classes.progress} variant="indeterminate" />
                            </div>
                        )}
                </Tile>
            </>
        );
    }
}

export default withSnackbar(withStyles(styles)(ItemChildren));
